import styled from 'styled-components'
import { BaseTextArea } from 'components/Inputs/Base'

export const Container = styled.div`
  max-height: 600px;
  overflow: hidden;
  justify-content: center;
  align-items: center;
`

export const StepRow = styled.div`
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  justify-self: center;
  margin: 7px 0 15px;
`

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
`

export const StepLabel = styled.p`
  width: 60px;
  color: #999999;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  margin: 0px;
`

export const StepCircle = styled.div`
  width: 35px;
  height: 35px;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background-color: ${({ step, currentStep }) => (
    currentStep.number > step.number
      ? '#44CF6C'
      : currentStep.number === step.number ? '#FFC100' : '#252525'
  )};

  p {
    color: #FFFFFF;
    font-size: 18px;
    font-weight: bold;
    margin: 0px;
  }
`

export const StepLine = styled.span`
  display: inline-block;
  position: absolute;
  top: 17px;
  left: 32px;
  width: ${({ currentStep }) => (currentStep.number - 1) * 165}px;
  height: 3px;
  z-index: 1;
  background-color: #44CF6C;
  transition: width 0.3s;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F7F7F7;
  border-radius: 15px;
`

export const FormField = styled(Container)`
  width: 100%;
  justify-content: flex-end;
  padding: 0px;
  margin-bottom: 10px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
`

export const Message = styled(Row)`
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const TextArea = styled(BaseTextArea)`
  width: 100%;
`

export const WarningText = styled.p`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  color: #FF3939;
`
